import axios from 'axios'
import { AUTH_HEADERS } from '../utils/config'
export default {
  getAll () {
    return axios.get(`${process.env.VUE_APP_BASE_URL}user`, AUTH_HEADERS())
  },

  get (id) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}user/${id}`, AUTH_HEADERS())
  },

  getAllWithRoles () {
    return axios.get(`${process.env.VUE_APP_BASE_URL}user/userRoles`, AUTH_HEADERS())
  },

  getAllArchived () {
    return axios.get(`${process.env.VUE_APP_BASE_URL}user/archived`, AUTH_HEADERS())
  },

  create (user) {
    return axios.post(`${process.env.VUE_APP_BASE_URL}user`, user, AUTH_HEADERS())
  },

  update (id, user) {
    return axios.put(`${process.env.VUE_APP_BASE_URL}user/${id}`, user, AUTH_HEADERS())
  },
  archive (id) {
    return axios.put(`${process.env.VUE_APP_BASE_URL}user/deactivate/${id}`, id, AUTH_HEADERS())
  },

  restore (id) {
    return axios.put(`${process.env.VUE_APP_BASE_URL}user/restore/${id}`, id, AUTH_HEADERS())
  },

  delete (id) {
    return axios.delete(`${process.env.VUE_APP_BASE_URL}user/delete/${id}`, AUTH_HEADERS())
  }
}
